import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getTutorHomeworkList,
  createTutorHomework,
  updateTutorHomeworkStatus,
  deleteTutorHomework,
} from "../../services/Academic-Services";
import AddTutorForm from "../../components/FormComponents/AddTutor";
import AddAssignmentForm from "../FormComponents/AddTutorAssignment";
import AddTutorHomeWorkForm from "../FormComponents/AddTutorHomeWork";
const TutorHomeWorkTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getTutorHomeworkList}
        deleteRow={deleteTutorHomework}
        updateStatus={updateTutorHomeworkStatus}
        tab1={"Academic"}
        tab2={"Tutor Homework"}
        AddForm={AddTutorHomeWorkForm}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default TutorHomeWorkTable;
